import {useEffect, useState} from "react";
import {useLocation} from "react-router-dom";
import {env} from "@bounce/shared/constants";
import {useAuth} from "@bounce/shared/contexts";
import {usePartnerUi} from "~/contexts/PartnerUiContext";
import {FADE_MS, MIN_DISPLAY_MS, KEYFRAMES_CSS, SPLASH_SESSION_KEY, SPLASH_Z_INDEX, palette} from "./constants";
import {SplashScene} from "./SplashScene";
import {SplashTextOverlay} from "./SplashTextOverlay";

const BACKOFFICE_PATH_PREFIXES = ["/backoffice", "/spring"];

export const WelcomeSplash = () => {
  const {partnerDomain} = useAuth();
  const {whiteLabelEnabled} = usePartnerUi();
  const {pathname} = useLocation();
  const [seen, setSeen] = useState(() => !!sessionStorage.getItem(SPLASH_SESSION_KEY));
  const [playing, setPlaying] = useState(false);
  const [exiting, setExiting] = useState(false);

  const enabled =
    !["local"].includes(env) &&
    !!partnerDomain &&
    !whiteLabelEnabled &&
    !BACKOFFICE_PATH_PREFIXES.some((prefix) => pathname.startsWith(prefix));
  const hidden = seen || !enabled;

  useEffect(() => {
    if (hidden) return;
    sessionStorage.setItem(SPLASH_SESSION_KEY, "1");
    requestAnimationFrame(() => setPlaying(true));
    const t = setTimeout(() => setExiting(true), MIN_DISPLAY_MS);
    return () => clearTimeout(t);
  }, [hidden]);

  useEffect(() => {
    if (!exiting) return;
    const t = setTimeout(() => setSeen(true), FADE_MS);
    return () => clearTimeout(t);
  }, [exiting]);

  if (hidden) return null;

  return (
    <div
      style={{
        position: "fixed",
        inset: 0,
        zIndex: SPLASH_Z_INDEX,
        overflow: "hidden",
        background: `linear-gradient(180deg, ${palette.duskTop} 0%, ${palette.duskMid} 34%, ${palette.duskDeep} 60%, ${palette.duskLow} 74%, ${palette.horizon} 87%)`,
        opacity: exiting ? 0 : 1,
        transition: `opacity ${FADE_MS}ms ease`,
      }}
    >
      <style>{KEYFRAMES_CSS}</style>
      <SplashScene playing={playing} />
      <SplashTextOverlay playing={playing} />
    </div>
  );
};
